import type { GrantSupportFilter, ProgramKind } from '@zoxo/shared';

import { awaitOnServer } from '../../lib/await-on-server';
import type { RouterContext } from '../../router';
import { parseListCookie, resolveListState, type ListState } from './list-state';
import { grantsQuery, type GrantFilters } from './use-grants';

export interface GrantListLoaderData {
  /** URL → 쿠키(zx_list) → 기본으로 정한 유효 상태. 컴포넌트는 render 중에 쿠키를 읽지 않는다. */
  state: ListState;
  /** 마감 D-n 의 기준 시각(ms). 서버와 hydration 첫 렌더가 같은 값으로 그린다 — 자정을 끼어도. */
  now: number;
}

/**
 * loader deps — 목록이 아는 키만 고른다. 라우터는 검증한 search 를 원래 search 위에 덮어써서
 * (`{...raw, ...validated}`) 모르는 키(`?kind=` · `?utm_source=` …)가 그대로 남는다. 그것이 API 로
 * 새면 422 → 500 이 된다. 컴포넌트도 `Route.useLoaderDeps()` 로 같은 값을 쓴다.
 */
export function grantListDeps(search: GrantFilters): GrantFilters {
  const { region, field, support, closed, sort, q } = search;
  return { region, field, support, closed, sort, q };
}

/** `/news` 와 기둥별 목록 다섯의 loader (docs/SSR.md 「쿠키」). */
export async function loadGrantList(
  context: RouterContext,
  search: GrantFilters,
  fixed: { support?: GrantSupportFilter; kind?: ProgramKind } = {},
): Promise<GrantListLoaderData> {
  const state = resolveListState(search, parseListCookie(context.readCookie()));
  await awaitOnServer(context.queryClient.ensureInfiniteQueryData(grantsQuery({ ...search, ...state, ...fixed })));
  return { state, now: Date.now() };
}
